// extracted by mini-css-extract-plugin
export default {"wrapper":"Tz-z","viewport":"Uz-z","container":"Vz-z","slide":"Wz-z"};